import { combineReducers } from "redux";
import productReducer from "./products";
import { cartReducer } from "./cart";
import { wishListReducer } from "./wishList";
import compareListReducer from "./compare";
import userReducer from "./user";
import blogReducer from "./blog";
import appointmentReducer from "./appointment";

const rootReducer = combineReducers({
  data: productReducer,
  cartList: cartReducer,
  wishList: wishListReducer,
  compareList: compareListReducer,
  user: userReducer,
  blog: blogReducer,
  appointment: appointmentReducer,
});

export default rootReducer;
